import React from "react";
import T from "prop-types";

import { isEmpty } from "2g-utils-common";
import { PlaceholderText } from "2g-placeholder";

export default function createBaseRenderer({
  name,
  kodKey,
  nazevKey,
  useMessage = () => (data, key) => data[key],
  placeholderText = "Lorem ipsum"
}) {
  function BaseRenderer({ val, showPlaceholder }) {
    const getMessage = useMessage();
    if (showPlaceholder)
      return <PlaceholderText>{placeholderText}</PlaceholderText>;
    if (isEmpty(val)) return null;
    const kodValue = kodKey && getMessage(val, kodKey);
    const nazevValue = nazevKey && getMessage(val, nazevKey);
    return (
      <span className={`b2b-RendererCiselnik b2b-RendererCiselnik--${name}`}>
        <>
          {kodValue ? (
            <span className="b2b-RendererCiselnik-kod">{kodValue}</span>
          ) : undefined}
          {nazevValue ? (
            <span className="b2b-RendererCiselnik-nazev">{nazevValue}</span>
          ) : undefined}
        </>
      </span>
    );
  }

  BaseRenderer.propTypes = {
    val: T.any,
    showPlaceholder: T.bool
  };

  return React.memo(BaseRenderer);
}
